import { bool, number, oneOfType, string } from 'prop-types';
import React from 'react';

export default function PageNavCurPageIndicator({ curRange, nextRange, totalCount, resourceType, noStyle }) {
    return (<>
        {totalCount > 0 && (<p
            style={{ ...noStyle === false && ({ paddingLeft: '43px',
                paddingTop: '24px' }),
            marginBottom: 0 }}>Showing <b>{curRange}</b> - <b>{nextRange}</b> of <b>{totalCount}</b> {resourceType}.</p>)}
    </>);
}

PageNavCurPageIndicator.propTypes = {
    curRange: oneOfType([number, string]),
    nextRange: oneOfType([number, string]),
    totalCount: oneOfType([number, string]),
    resourceType: string,
    noStyle: bool,
};